export const returnData = {
  configuration: {
    rawData: "Return without wrapper"
  },
  input: {
    returnData: "Return value"
  }
};
